import http from './http'

const basePath = '/achievement/honoraryAward'

const normalizeBody = (idOrPayload, payload) =>
  typeof idOrPayload === 'object' && idOrPayload !== null ? idOrPayload : { ...(payload || {}), id: idOrPayload }

const withId = (id) => `${basePath}/${id}`

export async function saveHonor(payload) {
  const res = await http.post(`${basePath}/saveDraft`, payload)
  return res.data
}

export async function submitHonor(payload) {
  const res = await http.post(`${basePath}/submit`, payload)
  return res.data
}

export async function createHonor(payload) {
  return payload?.isDraft ? saveHonor(payload) : submitHonor(payload)
}

export async function updateHonor(idOrPayload, payload) {
  const body = normalizeBody(idOrPayload, payload)
  if (typeof body?.isDraft === 'boolean') {
    return body.isDraft ? saveHonor(body) : submitHonor(body)
  }
  const res = await http.put(basePath, body)
  return res.data
}

export async function getHonor(id) {
  const res = await http.get(withId(id))
  return res.data
}

export async function listHonors(params) {
  const res = await http.get(basePath, { params })
  return res.data
}

export async function deleteHonor(id) {
  const res = await http.delete(withId(id))
  return res.data
}
